import { Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import SEO from "../components/SEO";
import CTABanner from "../components/CTABanner";
import { articles } from "../data/articles";
import { BookOpen, Clock, ArrowRight } from "lucide-react";
import { format } from "date-fns";

export default function Resources() {
  return (
    <SiteLayout>
      <SEO
        title="Mental Health Resources & Articles"
        description="Evidence-based guides on anxiety, depression, ADHD, telehealth, insurance, and getting started with psychiatric care in Maryland — written by our clinical team."
        path="/resources"
      />

      <section data-testid="resources-hero" className="container-pad max-w-7xl mx-auto pt-14 lg:pt-20 pb-10">
        <span className="pill">
          <span className="pill-dot" />
          <span>Clinical Team Writing</span>
        </span>
        <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-ink tracking-tight max-w-3xl leading-[1.05]">
          Plain-language guides on the questions we hear most.
        </h1>
        <p className="mt-5 text-lg text-muted_text max-w-2xl leading-relaxed">
          Each article is written by our clinical team and reviewed for accuracy. No SEO fluff, no diagnosis-by-quiz, no medical jargon. Just what we would tell a friend asking the same question at the kitchen table.
        </p>
      </section>

      <section data-testid="resources-grid" className="container-pad max-w-7xl mx-auto pb-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a) => (
            <article
              key={a.slug}
              data-testid={`resource-card-${a.slug}`}
              className="card-soft p-6 flex flex-col hover:shadow-md hover:-translate-y-0.5 transition"
            >
              <div className="flex flex-wrap items-center gap-2 mb-3">
                {a.tags?.map((t) => (
                  <span key={t} className="text-[10px] tracking-[0.16em] uppercase font-semibold text-sage-700">{t}</span>
                ))}
              </div>
              <h2 className="font-heading text-xl font-semibold text-ink leading-tight">
                <Link to={`/resources/${a.slug}`} className="hover:text-gold-700 transition">
                  {a.title}
                </Link>
              </h2>
              <p className="mt-3 text-sm text-muted_text leading-relaxed flex-1">{a.excerpt}</p>
              <div className="mt-5 flex items-center justify-between text-xs text-muted_text">
                <span className="inline-flex items-center gap-1">
                  <Clock className="w-3.5 h-3.5" strokeWidth={1.75} /> {a.readingMinutes} min read
                </span>
                <Link
                  to={`/resources/${a.slug}`}
                  className="inline-flex items-center gap-1 text-sage-700 hover:text-gold-700 font-medium"
                  data-testid={`resource-cta-${a.slug}`}
                >
                  Read <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.75} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      <CTABanner
        eyebrow="Ready to talk?"
        title="Nothing here replaces a real conversation."
        body="If any of this sounds like your season of life, book a first evaluation with a Maryland-licensed psychiatrist. Same-week openings, telehealth from your living room."
      />
    </SiteLayout>
  );
}
